export enum TestDefinitionLocations {
    Local = 1,
    External = 2,
    Both = 3,
}
